(() => {
  const COLLECTION_HANDLE = 'meet-your-new-hair-ritual';
  const SCRIPT_SRC = 'https://app.poweredbyhue.app/js/integration.js';

    const SLOTS = [
    { id: 'hue-grid-module-1', row: 1, position: 3, mobileIndex: 3,  productId: 'hair-ritual-collection' },
    { id: 'hue-grid-module-2', row: 2, position: 2, mobileIndex: 7,  productId: 'hair-ritual-collection-2' },
    { id: 'hue-grid-module-3', row: 4, position: 4, mobileIndex: 12, productId: 'hair-ritual-collection-3' },
  ];


  if (!window.location.pathname.includes(`/collections/${COLLECTION_HANDLE}`)) return;

  function loadHueScriptOnce() {
    if (window.__hueIntegrationLoaded) return;
    window.__hueIntegrationLoaded = true;
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;

    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.defer = true;
    document.head.appendChild(script);
  }

  function injectStylesOnce() {
    if (document.getElementById('hue-grid-module-styles')) return;

    const style = document.createElement('style');
    style.id = 'hue-grid-module-styles';
    style.textContent = `
      .hue-single-grid-module-item {
        display: flex;
        flex-direction: column;
      }
      .hue-single-grid-module-item > .hue-single-review-module,
      .hue-single-grid-module-item .hue-srv-wrapper,
      .hue-single-grid-module-item .hue-srv-content,
      .hue-single-grid-module-item .hue-swiper-wrapper {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
      }
      .hue-single-grid-module-item .hue-single-review-module__video-slider {
        aspect-ratio: 310 / 500;
        flex: 1 0 auto;
        height: auto;
      }
    `;
    document.head.appendChild(style);
  }

  function getColumnCount(grid) {
    const columns = getComputedStyle(grid).gridTemplateColumns;
    return columns && columns !== 'none' ? columns.split(' ').length : 1;
  }

  function createModule(slot) {
    const li = document.createElement('li');
    li.id = slot.id;
    li.className = 'product-grid__item hue-single-grid-module-item';
    li.setAttribute('data-page', '1');

    const placeholder = document.createElement('div');
    placeholder.className = 'hue-single-review-module';
    placeholder.setAttribute('data-hue-module', 'hue-single-review-module');
    placeholder.setAttribute('data-product-id', slot.productId);

    li.appendChild(placeholder);
    return li;
  }

  function insertHueModules() {
    const grid = document.querySelector('#ResultsList ul.product-grid');
    if (!grid) return;

    const columns = getColumnCount(grid);
    let hasInserted = false;

    SLOTS.forEach((slot) => {
      if (document.getElementById(slot.id)) return;

      const items = Array.from(grid.querySelectorAll(':scope > li.product-grid__item'));
      const index = columns === 1
        ? slot.mobileIndex - 1
        : (slot.row - 1) * columns + (slot.position - 1);

      if (index >= items.length) return; // not enough products for this slot

      grid.insertBefore(createModule(slot), items[index]);
      hasInserted = true;
    });

    if (hasInserted) loadHueScriptOnce();
  }

  function init() {
    insertHueModules();
    injectStylesOnce();

    const resultsList = document.querySelector('#ResultsList');
    if (!resultsList) return;

    new MutationObserver(insertHueModules).observe(resultsList, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
